import React from "react";
import { Link } from "react-router-dom";
import { DateDifference } from "../../utils/DateDIfference";
import { formatDate } from "../../utils/formatDate";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import timeSetter from "../../utils/timeSetter";
import Typography from "../Typography/Typography";
import { ChatLeftStyle } from "./ChatLeftStyle";

const ChatLeft = ({ data, APIChat }) => {
  return (
    <ChatLeftStyle>
      <div className="user d-flex">
        <img
          src={`https://crmapibama.metanext.biz/thumbnail/Profile/${
            !APIChat ? data?.user?.Image : APIChat?.user_writer?.Image
          }`}
          alt=""
          className="rounded-circle"
        />
        <Typography
          size="14px"
          weight="bold"
          className="me-3 ms-2 d-flex align-items-center"
        >
          {!APIChat
            ? (data?.user?.FirstName ? data?.user?.FirstName : "") +
              " " +
              (data?.user?.LastName ? data?.user?.LastName : "")
            : (APIChat?.user_writer?.FirstName
                ? APIChat?.user_writer?.FirstName
                : "") +
              " " +
              (APIChat?.user_writer?.LastName
                ? APIChat?.user_writer?.LastName
                : "")}
        </Typography>
        <Typography
          size="12px"
          className="d-flex align-items-center"
          primary="#b2b5c4"
        >
          {!APIChat
            ? MiladiToShamsi(data?.created_at) +
              " " +
              timeSetter(data?.created_at)
            : MiladiToShamsi(APIChat?.CluckChat) +
              " " +
              timeSetter(APIChat?.CluckChat)}
        </Typography>
      </div>
      <div className="text">
        <Typography pre>
          {!APIChat ? (
            <div
              dangerouslySetInnerHTML={{ __html: data?.content }}
              style={{ direction: "rtl" }}
            ></div>
          ) : (
            APIChat?.TextChat
          )}{" "}
          {!APIChat ? (
            data?.files.length ? (
              <a
                className="link"
                href={`https://crmapibama.metanext.biz/thumbnail/Ticket/${data?.files[0]?.TitleFile}`}
                target="_blank"
              >
                فایل ضمیمه شده
              </a>
            ) : (
              ""
            )
          ) : APIChat?.files?.length ? (
            <a
              className="link"
              href={`https://crmapibama.metanext.biz/thumbnail/ChatOnline/${APIChat?.files[0]?.TitleFile}`}
              target="_blank"
            >
              فایل ضمیمه شده
            </a>
          ) : (
            ""
          )}
        </Typography>
      </div>
    </ChatLeftStyle>
  );
};

export default ChatLeft;
